import LogLinkButton from './LogLinkButton';

export default LogLinkButton;
export * from './LogLinkButton';
